import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';

import { ReportFieldEnum } from 'Common/FieldEnum';
import { SiteComponent } from 'Common/SiteComponent';
import { SelectField } from 'Common/SemanticWrapper';
import { TitledCard } from 'Components';
import { STUDENT_ALLERGIES_FORM_NAME } from 'Common/FormEnum';
import { ReportFormatButtonGroup } from 'Components/forms/ReportFormatButtonGroup';

class StudentAllergiesForm extends Component {
  state = {
    siteData: '',
  };

  siteChange = data => {
    //any time the site changes, reset other dropdowns
    //to inital values
    if (this.state.siteData !== data) {
      this.props.change(`${ReportFieldEnum.Teacher}`, 'ALL');
      this.props.change(`${ReportFieldEnum.Grade}`, 'ALL');
      this.props.change(`${ReportFieldEnum.Allergen}`, '0');
      this.props.siteChange(data);
      this.setState({ siteData: data });
    }
  };

  render() {
    const { allergens, loading, disabled } = this.props;

    return (
      <Form>
        <TitledCard title={'Report Parameters'}>
          <Grid columns={3} style={{ paddingBottom: '10px' }}>
            <Grid.Row>
              <Grid.Column>
                <SiteComponent
                  name={ReportFieldEnum.Site}
                  onChange={this.siteChange}
                  isForm={true}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.Teacher}
                  component={SelectField}
                  type="text"
                  label="Teacher"
                  options={this.props.teachers}
                  loading={loading}
                  disabled={disabled}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.Grade}
                  component={SelectField}
                  type="text"
                  label="Grade"
                  options={this.props.grades}
                  loading={loading}
                  disabled={disabled}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.Allergen}
                  component={SelectField}
                  type="text"
                  label="Allergen"
                  options={allergens}
                  loading={loading}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <ReportFormatButtonGroup
                  formName={STUDENT_ALLERGIES_FORM_NAME}
                  fieldName={ReportFieldEnum.ReportFormat}
                  label="Report Format"
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
      </Form>
    );
  }
}

const validate = values => {
  const errors = {};
  if (!values[ReportFieldEnum.Site]) {
    errors[ReportFieldEnum.Site] = 'Site is required';
  }
  if (!values[ReportFieldEnum.Teacher]) {
    errors[ReportFieldEnum.Teacher] = 'Teacher is required';
  }
  if (!values[ReportFieldEnum.Grade]) {
    errors[ReportFieldEnum.Grade] = 'Grade is required';
  }
  if (!values[ReportFieldEnum.Allergen]) {
    errors[ReportFieldEnum.Allergen] = 'Allergen is required';
  }
  return errors;
};

export default reduxForm({
  validate,
  form: STUDENT_ALLERGIES_FORM_NAME,
  enableReinitialize: true,
})(StudentAllergiesForm);



// WEBPACK FOOTER //
// ./src/pages/studentallergies/components/StudentAllergiesForm.js